export default __webpack_public_path__ + "static/media/logoHuge.b907f2cc.png";